module.exports = __webpack_public_path__ + "files/66a4d4604026f159bdaa126ca29e5ec2.png";